import { deliveryStatus } from '@aircare/delivery-dates';

class ProductImageBadges extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#updateStock();
    document.addEventListener('visibilitychange', this.#updateStock);
    this.#timer = setInterval(this.#updateStock, 60000);
  }

  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.#updateStock);
    clearInterval(this.#timer);
  }

  #updateStock = () => {
    const badge = this.querySelector('[data-stock-badge]');
    if (!(badge instanceof HTMLElement)) return;
    const { status } = deliveryStatus(this.dataset.available === 'true', this.dataset.leadTime || '');
    badge.hidden = status !== 'in-stock';
  };
}

if (!customElements.get('ac-product-image-badges')) {
  customElements.define('ac-product-image-badges', ProductImageBadges);
}
